export default __webpack_public_path__ + "60fe442d0133d548f8365f77de863e92.png";